module.exports = __webpack_public_path__ + "img/redWave.c8accbd5.svg";